var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsDanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fefefe;\n      }\n\n      .st1 {\n        fill: #1976d2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.74,31.24l405.8-.28c13.05,1.37,22.36,10.33,23.49,23.51v402.08c-.36,13.37-10.32,23.29-23.49,24.5H54.46c-13.01-1.29-22.3-10.42-23.5-23.5V54.46c1.11-12.1,9.04-20.69,20.78-23.22ZM150,287v-59l-60,30v29h-22v44h22c1.01,22.15-1.37,45.48,0,67.49,2.73,43.71,25.3,50.97,65.48,48.5,3.67-.23,26.86-3.27,28.54-4.45,1.08-.76,1.02-1.84,1.01-2.99l-4.06-38.54c-7.37,1.97-21.96,7.33-28.03.53-1.04-1.16-2.97-6.82-2.97-8.03v-62.5h33v-44h-33ZM445,228h-61v72l-16.32-11.18c-114.67-47.04-128.8,166.85-22.19,158.16,18.97-1.55,31.86-11.98,43.52-25.98v22h56v-215ZM233.76,398.26c-26.5,3.87-25.72,45.57.85,48.62,37.88,4.34,37.31-54.19-.85-48.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445,228v215h-56v-22c-11.66,14.01-24.55,24.44-43.52,25.98-106.61,8.69-92.48-205.2,22.19-158.16l16.32,11.18v-72h61ZM353.73,328.24c-32.37,5.4-26.87,89,13.97,72.96,27.05-10.63,23.53-79.21-13.97-72.96Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,287h33v44h-33v62.5c0,1.21,1.93,6.87,2.97,8.03,6.07,6.8,20.66,1.45,28.03-.53l4.06,38.54c.01,1.15.07,2.24-1.01,2.99-1.68,1.18-24.88,4.22-28.54,4.45-40.18,2.47-62.75-4.79-65.48-48.5-1.38-22.01,1-45.34,0-67.49h-22v-44h22v-29l60-30v59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.76,398.26c38.16-5.57,38.73,52.97.85,48.62-26.57-3.05-27.35-44.75-.85-48.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.73,328.24c37.5-6.25,41.02,62.33,13.97,72.96-40.84,16.04-46.33-67.56-13.97-72.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsDanceLogo);
export default __webpack_public_path__ + "static/media/tools-dance-logo.45daadc2bc47b1d0efe841663fa608b4.svg";
export { ForwardRef as ReactComponent };